export const DRAWER_WIDTH = 240;
export type InputSize = 'small' | 'medium';
